import React from 'react';
import Icon from '../css/Icon';
import { useState } from 'react';

export const Banner = () => {
    const [dismiss, setDismiss] = useState(false);
    const handleDismiss = (event) => {
        event.preventDefault();
        setDismiss(true);
    };
    return (
        <div>
            {dismiss === false && <div style={{ margin: '-1.5% -2.8% 0 -2.8%' }}>
                <div className="indi-notification indi-notification--info">
                    <Icon name="information" class="indi-icon" />
                    <a style={{ float: 'right', marginRight: '-20px' }} href="#" onClick={handleDismiss}>
                        <Icon name="close" class="indi-icon" />
                    </a>
                    Beginning August 2026, USAC will use SAM.gov  banking information to remit payment for all Universal Service Fund (USF) invoices. All service providers and E-Rate participants who use the BEAR invoicing method to receive
                    USF disbursements must have an active SAM.gov Unique Entity Identifier (UEI) on their FCC Form 498 and must have a valid bank
                    account associated with their UEI. For more information, see the                    
                    <a title="SAM.gov UEI Requirement - Universal Service Administrative Company" href="https://www.usac.org/about/sam-gov-uei-requirement/" target="_blank"> SAM.gov UEI Requirement webpage.</a>
                </div>
            </div>}
        </div>
    );
};